import React from "react";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import {
  Wrapper,
  ImageWrapper,
  Content,
  Subtitle,
  Title,
  LinksList,
  LinkItem,
} from "./index.styled";

const Pagination = ({ data, className }) => {
  return (
    <Wrapper className={className}>
      <ImageWrapper>
        <GatsbyImage image={getImage(data?.images[0].file)} alt="" />
      </ImageWrapper>
      <Content>
        <Subtitle>{data.subtitle}</Subtitle>
        <Title to={data.link}>{data.title}</Title>
        <LinksList>
          {data.anchors?.firstList?.map((item, index) => {
            return (
              <React.Fragment key={`pagination-link-${index}`}>
                <LinkItem
                  className={item.divider && "show-divider"}
                  to={item.url}
                >
                  {item.text}
                </LinkItem>
              </React.Fragment>
            );
          })}
        </LinksList>
        {data.anchors?.secomdList && (
          <LinksList>
            {data.anchors?.secomdList?.map((item, index) => {
              return (
                <React.Fragment key={`pagination-link-${index}`}>
                  <LinkItem
                    state={{
                      anchor: item.anchor,
                      scrollToSection: item.scrollToID,
                    }}
                    className={item.divider && "show-divider"}
                    to={item.url}
                  >
                    {item.text}
                  </LinkItem>
                </React.Fragment>
              );
            })}
          </LinksList>
        )}
      </Content>
    </Wrapper>
  );
};

export default Pagination;
